import React, { Component } from "react";

// Bootstrap
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";

class MonitoringWebcams extends Component {
  render() {
    return (
      <Container className="my-5">
        <Row className="pt-5">
          {/* <Col lg={4}>
            <h5 className="font-weight-bold">LERZ Webcams</h5>
            <p>This assortment of web cameras hosted by USGS provides a way for residents to monitor Fissure 8, the recent lava flows in the LERZ, Pu’u O’o, Halema’uma’u, and Mauna Loa.</p>
            <CardGroup>
              <a className="text-reset text-decoration-none" href="https://hvo.wr.usgs.gov/cams/L8cam/images/M.jpg">
                <Card className="mb-3">
                  <Card.Body className="p-4">
                    <h4 className="card-title">Looking Towards Leilani Estates</h4>
                    <img className="img-fluid" alt="" src="https://hvo.wr.usgs.gov/cams/L8cam/images/M.jpg" />
                  </Card.Body>
                </Card>
              </a>
              <a className="text-reset text-decoration-none" href="https://hvo.wr.usgs.gov/cams/L3cam/images/M.jpg">
                <Card className="mb-3 border-0">
                  <Card.Body className="p-4">
                    <h4 className="card-title">Kilauea, LERZ, Mauka of Hwy 130</h4>
                    <img className="img-fluid" alt="" src="https://hvo.wr.usgs.gov/cams/L3cam/images/M.jpg" />
                  </Card.Body>
                </Card>
              </a>
            </CardGroup>
          </Col> */}
          {/* Halema’uma’u */}
          <Col lg={12} className="mb-4 mt-5">
            <h5 className="font-weight-bold">Halema’uma’u Webcams</h5>
          </Col>

          {/* New eruption */}
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/B1cam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">Kīlauea Volcano Live Stream - Halemaʻumaʻu crater</h4>
                  <iframe width="100%" src="https://www.youtube-nocookie.com/embed/Q5M-5XFplo0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </Card.Body>
              </Card>
            </a>
          </Col>
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/B1cam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">Halemaʻumaʻu, lava lake, and down-dropped block [KWcam]</h4>
                  <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/B1cam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/S1cam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">Halemaʻumaʻu crater and lava lake [S1cam]</h4>
                  <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/S1cam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/F1cam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">Halemaʻumaʻu Overlook Vent</h4>
                  <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/F1cam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/KWcam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">W. Caldera &amp; Jaggar</h4>
                  <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/KWcam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>


          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/KIcam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">Kīlauea Caldera</h4>
                  <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/KIcam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/KEcam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">East Caldera</h4>
                  <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/KEcam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>
          {/* <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://hvo.wr.usgs.gov/cams/K3cam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">Very Bottom of Halema'uma'u</h4>
                  <img className="img-fluid" alt="" src="https://hvo.wr.usgs.gov/cams/K3cam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col> */}
          {/* <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/F1cam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">Halemaʻumaʻu and water lake - thermal image [F1cam]</h4>
                  <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/F1cam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col> */}
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/F1cam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/MKcam/images/M.thumb.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>

          {/* Pu’u O’o */}
          <Col lg={12} className="mb-4 mt-5">
            <h5 className="font-weight-bold">Pu’u O’o Webcams</h5>
          </Col>
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/PGcam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">PGcam, LERZ, near Puna Geothermal Venture</h4>
                  <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/PGcam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/L1cam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  {/* <h4 className="card-title">Alaʻili Steam Vents, near ʻĪʻīlewa Crater</h4> */}
                  <h4 className="card-title">East Rift</h4>
                  <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/L1cam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://hvo.wr.usgs.gov/cams/POcam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">Crater Rim of Pu’u O’o</h4>
                  <img className="img-fluid" alt="" src="https://hvo.wr.usgs.gov/cams/POcam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://hvo.wr.usgs.gov/cams/PEcam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">Pu’u O’o East Slope</h4>
                  <img className="img-fluid" alt="" src="https://hvo.wr.usgs.gov/cams/PEcam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://hvo.wr.usgs.gov/cams/PScam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">Pu’u O’o South Slope</h4>
                  <img className="img-fluid" alt="" src="https://hvo.wr.usgs.gov/cams/PScam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>
          <Col lg={4}>
            <a className="text-reset text-decoration-none" href="https://hvo.wr.usgs.gov/cams/R3cam/images/M.jpg">
              <Card className="mb-3">
                <Card.Body className="p-4">
                  <h4 className="card-title">Pu’u O’o Looking SW</h4>
                  <img className="img-fluid" alt="" src="https://hvo.wr.usgs.gov/cams/R3cam/images/M.jpg" />
                </Card.Body>
              </Card>
            </a>
          </Col>
          {/* Mauna Loa */}
          <Col lg={12} className="mb-4 mt-5">
            <h5 className="font-weight-bold">Mauna Loa Webcams</h5>
          </Col>
          <Col lg={4}>
            <CardGroup>
              <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/M1cam/images/M.jpg">
                <Card className="mb-3">
                  <Card.Body className="p-4">
                    <h4 className="card-title">Mauna Loa from the HVO Observation Tower</h4>
                    <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/M1cam/images/M.jpg" />
                  </Card.Body>
                </Card>
              </a>
            </CardGroup>
          </Col>
          <Col lg={4}>
            <CardGroup>
              <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/MOcam/images/M.jpg">
                <Card className="mb-3">
                  <Card.Body className="p-4">
                    <h4 className="card-title">Mokuʻāweoweo Caldera</h4>
                    <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/MOcam/images/M.jpg" />
                  </Card.Body>
                </Card>
              </a>
            </CardGroup>
          </Col>
          <Col lg={4}>
            <CardGroup>
              <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/MTcam/images/M.jpg">
                <Card className="mb-3">
                  <Card.Body className="p-4">
                    <h4 className="card-title">Mokuʻāweoweo Caldera Thermal</h4>
                    <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/MTcam/images/M.jpg" />
                  </Card.Body>
                </Card>
              </a>
            </CardGroup>
          </Col>
          <Col lg={4}>
            <CardGroup>
              <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/MLcam/images/M.jpg">
                <Card className="mb-3">
                  <Card.Body className="p-4">
                    <h4 className="card-title">Mokuʻāweoweo Caldera</h4>
                    <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/MLcam/images/M.jpg" />
                  </Card.Body>
                </Card>
              </a>
            </CardGroup>
          </Col>
          <Col lg={4}>
            <CardGroup>
              <a className="text-reset text-decoration-none" href="https://volcanoes.usgs.gov/observatories/hvo/cams/M2cam/images/M.jpg">
                <Card className="mb-3">
                  <Card.Body className="p-4">
                    <h4 className="card-title">Middle of SW Rift</h4>
                    <img className="img-fluid" alt="" src="https://volcanoes.usgs.gov/observatories/hvo/cams/M2cam/images/M.jpg" />
                  </Card.Body>
                </Card>
              </a>
            </CardGroup>
          </Col>
          <Col lg={4}>
            <CardGroup>
              <a className="text-reset text-decoration-none" href="https://hvo.wr.usgs.gov/cams/M3cam/images/M.jpg">
                <Card className="mb-3">
                  <Card.Body className="p-4">
                    <h4 className="card-title">Upper SW Rift</h4>
                    <img className="img-fluid" alt="" src="https://hvo.wr.usgs.gov/cams/M3cam/images/M.jpg" />
                  </Card.Body>
                </Card>
              </a>
            </CardGroup>
          </Col>
          <Col lg={4}>
            <CardGroup>
              <a className="text-reset text-decoration-none" href="https://hvo.wr.usgs.gov/cams/SPcam/images/M.jpg">
                <Card className="mb-3">
                  <Card.Body className="p-4">
                    <h4 className="card-title">Mauna Loa summit, Moku'āweoweo caldera</h4>
                    <img className="img-fluid" alt="" src="https://hvo.wr.usgs.gov/cams/SPcam/images/M.jpg" />
                  </Card.Body>
                </Card>
              </a>
            </CardGroup>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default MonitoringWebcams;
